import { MutationTree } from 'vuex';
import _ from 'lodash'

import { AuthState } from '@/store/auth/types';
import { Tutor } from '@/store/tutors/types';

const mutations: MutationTree<AuthState> = {
  authenticated: (state: AuthState,
    { accessToken, profile }:{ accessToken: string, profile: Tutor }) => {
    state.token = accessToken;
    state.profile = {
      ...profile,
      name: _.chain(profile)
        .pick(['firstName', 'middleName', 'lastName'])
        .omitBy(_.isEmpty)
        .values()
        .join(' ')
        .value(),
    }
  },
  clearedAuthentication: (state: AuthState) => {
    state.token = null;
    state.profile = null;
  },
};

export default mutations;
